<template>
  <div>
    <v-container>
      <v-row no-gutters justify="center">
        <v-col cols="10" md="8" xs="12" class="px-2">
          <v-btn
              block
              :loading="loading"
              color="primary"
              @click="submit"
          >
            Salvar alterações
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-row class="mx-0">
      <location-menu-sections
          :limit="100"
          :value="sections"
          v-on:change="updateData"
      />
    </v-row>

    <v-btn
        :loading="loading"
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        right
        color="primary"
        @click="submit"
    >
      <v-icon>mdi-content-save-outline</v-icon>
    </v-btn>

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import {handleResponseError} from '@/api/handleError'
import LocationMenuSections from '@/views/Locations/Components/LocationMenuSections'
import {mapState} from 'vuex'
import { get } from 'lodash'

export default {
  name: 'LocationMenusTab',
  components: {
    LocationMenuSections,
  },
  computed: {
    ...mapState({
      foodMenu: state => state.locations.foodMenu,
      location: state => state.locations.location
    })
  },
  methods: {
    setData() {
      this.sections = get(this.foodMenu, 'data.sections', [])
      this.formData = get(this.foodMenu, 'data.sections', [])
    },
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
    updateData: function(data) {
      this.formData = data
    },
    submit: async function() {
      const data = this.formData
      try {
        this.loading = true

        const id = get(this.location, 'data.id')
        if (!id) return

        await this.$store.dispatch('locations/updateFoodMenu', { id, data })
          .then(() => this.showNotification('Alterações salvas!', 'green darken-2'))
          .catch(e => {
            const message = handleResponseError(e, 'Ocorreu um erro ao enviar os dados.')
            this.showNotification(message, 'red darken-2')
          })
        this.loading = false
      } catch (e) {
        const message = handleResponseError(e, 'Ocorreu um erro ao enviar os dados.')
        this.showNotification(message, 'red darken-2')
      }
    },
    showNotification: function(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  },
  data: () => ({
    fab: false,
    loading: false,
    sections: [],
    formData: [],
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    }
  }),
  created() {
    this.setData()
  },
  watch: {
    foodMenu: function() {
      this.setData()
    },
    location: function() {
      this.setData()
    }
  }
}
</script>

<style scoped>
</style>